import { StatusChip } from '@components/status-chip';
import { Typography, Grid, Button, Theme, withStyles, Avatar, Tooltip } from '@material-ui/core';
import React, { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { red, amber, lightGreen, grey, cyan } from '@material-ui/core/colors';
import DeleteIcon from '@material-ui/icons/DeleteRounded';
import SaveIcon from '@material-ui/icons/SaveRounded';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { useToggle } from '@lib/common';
import { ColoredButton } from '@components/colored-elements';
import { OutlinedFlagOutlined } from '@material-ui/icons';
import { DealSourceChip } from '@components/deal-source-chip';
import { DealSourceType } from '@lib/deals';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { orange, blue, deepOrange, pink, indigo, teal } from '@material-ui/core/colors';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Chip,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Divider,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  Select,
} from '@material-ui/core';
import CompanyDefaultIcon from '@icon/company-default';
import { readableDate, toPercentage, YmdStrToDate } from '@lib/common';
import { format, compareAsc } from 'date-fns';
import formatDistance from 'date-fns/formatDistance';
import differenceInDays from 'date-fns/differenceInDays';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import { useDefaultImage } from '@lib/common';
import { uniq, uniqBy } from 'lodash';
import { ColoredAvatar, ColoredChip } from '@components/colored-elements';
import { useMemo } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import { capitalCase, useRecentInjector, useServerPagination, vtrUrl } from '@lib/common';
import { RelationSourceChip } from '@components/relation-source-chip';
import { IngestionMethodChip } from '@components/ingestion-method';
import { IngestionMethod } from '@lib/company-content-relations';
import { RelationSourceType } from '@lib/company-content-relations';
import { useController } from 'react-hook-form';
import styled from 'styled-components';
import InputAdornment from '@material-ui/core/InputAdornment';
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
import { useCompanyLoader } from 'services/company-dataloader.service';
import { Skeleton } from '@material-ui/lab';
import CancelIcon from '@material-ui/icons/CancelRounded';

import { GrResources, FaSourcetree, BsBook, FaNewspaper } from '@icon/react-icons';
import { windowObj } from '@lib/common';
import { rbac } from '@lib/common';

const listObj = (label: string, value: string | number) => ({ label, value });
const publishOptions = [
  listObj('Publish', 2),
  listObj('Unpublish', -1)
];

const relationSourceOptions = [listObj('Vitrina', 'Vitrina'), listObj('Client', 'Client')];

export function RelationFormActions({
  relationData,
  onDelete,
  onCancel,
  submitForm = null,
  createRelation = false,
  hidePublishSource = false,
}) {
  const history = useHistory();
  const { company_vtr_id } = useParams<{ company_vtr_id: string }>();
  const { relationId } = useParams<{ relationId: string }>();

  const form = useFormContext();
  const watchOnServiceId = form.watch('service_provided_id');
  useEffect(() => {
    if (![RelationSourceType.Vitrina, RelationSourceType.Client].includes(relationData.source))
      form.setValue('source', 'Vitrina');
    // if(relationData.is_publish==null)
    // form.setValue('is_publish', 0);
  }, []);

  const RelationPublishStatus = useCallback(() => {
    const {
      field: { value, onChange },
    } = useController({
      name: 'is_publish',
      control: form.control,
      defaultValue: 2,
    });

    return (
      // <FormControl variant={watchOnServiceId === 835 ? 'filled' : 'outlined'} fullWidth>
      //   <InputLabel id="relation-publish-status">Published Status</InputLabel>
      //   <Select
      //     disabled={watchOnServiceId === 835}
      //     labelId="relation-publish-status"
      //     id="relation-publish-status"
      //     name="is_publish"
      //     native
      //     value={value}
      //     onChange={onChange}
      //     label="Publish Status">
      //     <option value={0}>Unpublished</option>
      //     <option value={1}>Published</option>
      //   </Select>
      // </FormControl>
      <PublishContainer>
        <TextField
          id="relation-publish-status"
          select
          SelectProps={{
            native: true,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PublishRoundedIcon style={{ color: 'white' }} />
              </InputAdornment>
            ),
            disableUnderline: true,
          }}
          value={value}
          onChange={onChange}
          name="is_publish">
          {publishOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>
      </PublishContainer>
    );
  }, [watchOnServiceId]);

  const RelationSource = useCallback(() => {
    const {
      field: { value, onChange },
    } = useController({
      name: 'source',
      control: form.control,
      defaultValue: 'Vitrina',
    });

    return (
      <RelationSourceContainer>
        <TextField
          id="relation-source"
          select
          SelectProps={{
            native: true,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FaNewspaper style={{ color: 'white', paddingLeft: '5px' }} />
              </InputAdornment>
            ),
            disableUnderline: true,
          }}
          value={value}
          onChange={onChange}
          name="source">
          {relationSourceOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>
      </RelationSourceContainer>
    );
  }, []);

  const onSave = () => {
    submitForm && submitForm(form.getValues());
  };
  const onCancelRelation = () => {
    onCancel && onCancel();
  };
  const onDeleteFinish = () => {
    onDelete && onDelete();
  };
  const srcList = useMemo(() => {
    return [
      `${windowObj.RAZZLE_S3_BUCKET_URL}/${company_vtr_id}.png`,
      '/images/company_default.svg',
    ].filter(e => e);
  }, []);

  const { src: fallbackedSource } = useDefaultImage({
    srcList,
    defaultSrc: '/images/company_default.svg',
    useSuspense: false,
  });
  const [editOpen, , showEditDialog, hideEditDialog] = useToggle(false);
  //  const { loading, data: company, error } = useCompanyLoader(company_vtr_id);
  return (
    <Grid container spacing={2} justify="space-between">
      {/* <Grid item xs>
        <Typography display="inline">Status</Typography>&nbsp;
        <StatusChip status={deal.status || 'not_reviewed'} />
        &nbsp;
        <DealSourceChip
          type={createDeal ? DealSourceType.deli : deal?.deal_source?.deal_source_type}
        />
      </Grid> */}
      <Grid item>
        {/* <CellForCompanyName
          companyVtrId={company_vtr_id}
          companyVtrName={relationData.company.vtr_company_name}
        /> */}
        <Grid container>
          {
            <>
              
              <RelationSourceChip
                type={createRelation ? RelationSourceType.Vitrina : relationData?.source}
              />
              &nbsp; &nbsp;
              <IngestionMethodChip
                type={createRelation ? IngestionMethod.DELI : relationData?.ingestion_method}
              />
              <RelationSourceChip
                type={createRelation ? RelationSourceType.Vitrina : relationData?.user_id}
              />
            </>
          }
          {/* {
            !createRelation && (
              <>
                <Grid item>
                  <SingleBuyerSellerCell
                    name={relationData.company?.vtr_company_name || ''}
                    vtrId={company_vtr_id}
                    type="COMPANY"
                    avatarImg={fallbackedSource}
                  />
                </Grid>
                <Grid item style={{ alignSelf: 'center' }}>
                  <Chip
                    size="small"
                    component={Link}
                    target="_blank"
                    href={vtrUrl(company_vtr_id, 'COMPANY')}
                    icon={<LaunchIcon />}
                    label={`ID: ${company_vtr_id}`}
                    clickable
                    color="primary"
                  />
                </Grid>
              </>
            )
            // : company ? (
            //   <>
            //     <Grid item>
            //       <SingleBuyerSellerCell
            //         name={company.vtr_company_name || ''}
            //         vtrId={company_vtr_id}
            //         type="COMPANY"
            //         avatarImg={fallbackedSource}
            //       />
            //     </Grid>
            //     <Grid item style={{ alignSelf: 'center' }}>
            //       <Chip
            //         size="small"
            //         component={Link}
            //         target="_blank"
            //         href={vtrUrl(company_vtr_id, 'COMPANY')}
            //         icon={<LaunchIcon />}
            //         label={`ID: ${company_vtr_id}`}
            //         clickable
            //         color="primary"
            //       />
            //     </Grid>
            //   </>
            // ) : (
            //   <Skeleton
            //     style={{ display: 'block' }}
            //     variant="rect"
            //     width={200}
            //     height={70}
            //     animation="wave"
            //   />
            // )
          } */}
        </Grid>
      </Grid>
      <Grid item style={{ alignSelf: 'center', display: 'flex' }}>
        {/* {!createRelation && (
          <>
            <RelationSourceChip
              type={createRelation ? RelationSourceType.DELI : relationData?.source}
            />
            &nbsp; &nbsp;
          </>
        )} */}
        {!hidePublishSource ? (
          <>
            <RelationSource />
            <RelationPublishStatus />
          </>
        ) : null}
        <ColoredButton
          colored={red[500]}
          coloredHover={red[900]}
          startIcon={<CancelIcon />}
          variant="contained"
          onClick={() => history.push('/c3-page/search')}>
          Cancel
        </ColoredButton>
        &nbsp; &nbsp;
        <ColoredButton
          colored={lightGreen[700]}
          coloredHover={lightGreen[900]}
          startIcon={<SaveIcon />}
          variant="contained"
          disabled={rbac('Relation_Save', '', 'Button')}
          onClick={onSave}>
          Save
        </ColoredButton>
        &nbsp; &nbsp;
        {!createRelation && (
          <>
            <Button
              color="primary"
              onClick={showEditDialog}
              startIcon={<DeleteIcon />}
              disabled={rbac('Relation_Delete', '', 'Button')}
              variant="contained">
              Delete
            </Button>
            <DeleteRelationDialog
              relationId={relationId}
              onDeleteFinish={onDeleteFinish}
              open={editOpen}
              onClose={hideEditDialog}
            />
          </>
        )}
      </Grid>
      {/* <Grid item>
        <Button
          color="primary"
          onClick={onCancelRelation}
          startIcon={<CloseIcon />}
          variant="contained">
          Cancel
        </Button>
      </Grid> */}
    </Grid>
  );
}

export const CellForCompanyName = ({ companyVtrId, companyVtrName }) => {
  const classes = useStyles();
  const srcList = useMemo(() => {
    return [
      `${windowObj.RAZZLE_S3_BUCKET_URL}/${companyVtrId}.png`,
      '/images/company_default.svg',
    ].filter(e => e);
  }, []);

  const { src: fallbackedSource } = useDefaultImage({
    srcList,
    defaultSrc: '/images/company_default.svg',
    useSuspense: false,
  });

  return (
    companyVtrId && (
      <Tooltip title={''}>
        <ListItem style={{ padding: 0 }} component="div">
          <ListItemAvatar style={{ display: 'flex', minWidth: 0, marginRight: 6 }}>
            <Avatar
              alt={`${companyVtrId}`}
              src={fallbackedSource}
              className={[
                classes.containedImage,
                // , classes.large
              ].join(' ')}
            />
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography variant="body2">
                {`${companyVtrName}`} &nbsp;
                <Chip
                  size="small"
                  component={Link}
                  target="_blank"
                  href={vtrUrl(companyVtrId, 'COMPANY')}
                  icon={<LaunchIcon />}
                  label={`ID: ${companyVtrId}`}
                  clickable
                  color="primary"
                />
              </Typography>
            }
          />
        </ListItem>
      </Tooltip>
    )
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    orange: {
      color: theme.palette.getContrastText(deepOrange[500]),
      backgroundColor: deepOrange[500],
    },
    contentImg: {
      width: '40px',
      height: '75px',
      marginRight: '5px',
    },
    containedImage: {
      '& .MuiAvatar-img': {
        objectFit: 'contain',
        // border: '1px solid lightgray',
        // backgroundColor: 'lightgray',
      },
    },
  })
);

export function DeleteRelationDialog({ relationId, onDeleteFinish = null, onClose = null, open }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to delete this relation?
      </DialogTitle>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={() => onDeleteFinish(relationId)} color="primary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const PublishContainer = styled.div`
  // display: inline;
  margin-right: 10px;
  border-radius: 4px;
  background: ${amber[900]};
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);
  select {
    padding-top: 8px;
    // padding-bottom: 6px;
    color: white;
    option {
      color: black;
    }
  }
  .MuiSelect-iconOutlined {
    color: white;
  }
`;

const RelationSourceContainer = styled.div`
  // display: inline;
  margin-right: 10px;
  border-radius: 4px;
  background: ${cyan[800]};
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);
  select {
    padding-top: 8px;
    // padding-bottom: 6px;
    color: white;
    option {
      color: black;
    }
  }
  .MuiSelect-iconOutlined {
    color: white;
  }
`;
